import React from "react";
import styles from "../../../Styles/Modules/AutoPlaySelector.module.scss";
import Button from "../../../Elements/Button/Button";
import { Settings } from "../../../settings";
import { setAutoSpinCount } from "../../../State/Slices/settingsSlice";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const AutoPlaySelector = () => {
  // Accessing the autoSpinCount from the Redux store
  const { autoSpinCount } = useSelector((state) => state.settings);

  // Getting the translation function from react-i18next
  const { t } = useTranslation();

  // Rendering the component
  return (
    // Main container for the autoplay selector with scoped styles
    <div className={styles.autoPlaySelector}>
      {/* Mapping over the autoplay options defined in Settings */}
      {Settings.AUTO_PLAY_OPTIONS.map((option) => (
        // Rendering a Button component for each autoplay option
        <Button
          key={option} // Unique key for each button, using the option value
          action={() => setAutoSpinCount(option)} // Dispatching action to update autoSpinCount
          title={`${t("autoplay_option")} ${option}`} // Translated title for accessibility
          text={option} // Text displayed on the button
          modifier="buttonAutoPlaySelector" // Modifier for additional styling
          active={autoSpinCount === option} // Determines if the button is active
        />
      ))}
    </div>
  );
};

export default AutoPlaySelector;
